import { string } from 'zod'
import { DEFAULT_MANDATORY_MESSAGE } from '~/constants'

export const emailValidationSchema = string({ required_error: DEFAULT_MANDATORY_MESSAGE })
  .min(1, { message: DEFAULT_MANDATORY_MESSAGE })
  .email({ message: 'Invalid email format' })

export const passwordSchema = string({
  required_error: DEFAULT_MANDATORY_MESSAGE,
})
  .min(1, { message: DEFAULT_MANDATORY_MESSAGE })
  .min(8, { message: 'At least 8 characters.' })
